import React from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import "./SingleGrid.css";

/*
function useResponsiveFont(numberOfQueueColumns) {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const isLandscape = window.matchMedia("(orientation: landscape)").matches;
  if (isMobile && isLandscape) {
    return Math.max(1, (window.innerWidth / numberOfQueueColumns) * 0.05) + "rem";
  } else if (isMobile) {
    return Math.max(0.9, 2.5 - numberOfQueueColumns * 0.1) + "rem";
  } else {
    return Math.max(1.2, 3.5 - numberOfQueueColumns * 0.15) + "rem";
  }
}
*/

/*
function useResponsiveFont(numberOfQueueColumns) {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const isLandscape = window.matchMedia("(orientation: landscape)").matches;
  //const isSmallMobile = window.matchMedia("(max-width: 480px)").matches; // iPhone-ish

  // Height-based small landscape phone detection (works for iPhone)
  const isSmallLandscapePhone = window.matchMedia(
    "(orientation: landscape) and (max-height: 480px)"
  ).matches;


  if (isSmallLandscapePhone) {
    // iPhone landscape: tight, safe size to avoid overflow
    //return "1rem";
    // Or slightly responsive, still capped:
    return Math.min(1.1, Math.max(0.9, 1.3 - numberOfQueueColumns * 0.05)) + "rem";
  } else if (isMobile && isLandscape) {
    // Larger mobile landscape (small tablets)
    return Math.max(1, (window.innerWidth / numberOfQueueColumns) * 0.05) + "rem";
  } else if (isMobile) {
    // Mobile portrait (iPhone + iPad portrait)
    return Math.max(1.1, 2.8 - numberOfQueueColumns * 0.12) + "rem";
  } else {
    // Desktop + iPad landscape
    return Math.max(1.2, 3.5 - numberOfQueueColumns * 0.15) + "rem";
  }
}
  */

function useResponsiveFont(numberOfQueueColumns) {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (isMobile) {
    return Math.max(0.9, 2.5 - numberOfQueueColumns * 0.1) + "rem";
  } else {
    return Math.max(1.2, 3.5 - numberOfQueueColumns * 0.15) + "rem";
  }
}

const SingleGrid = ({ gridItems, onCellFocused, headerName, numberOfQueueColumns }) => {

  const fontSize = useResponsiveFont(numberOfQueueColumns);

  // Dynamically scale font size based on lane count
  //const fontSize = Math.max(1.2, 3.5 - numberOfQueueColumns * 0.15) + "rem";

  const columnDefs = [
    {
      field: "StudentID",
      headerName,
      headerClass: "grid-header-center",
      resizable: false,
      cellStyle: {
        fontSize,
        fontWeight: "600",
        textAlign: "center",
        color: "#2c3e50",
        backgroundColor: "#ffffff",
        border: "none",
      },
      flex: 1,
    },
  ];

  return (
    //<div className="ag-theme-quartz grid-lane">
    <div
      className="ag-theme-quartz"
      style={{
        flex: 1,
        width: "100%",
        height: "100%",
        border: "none",
        boxShadow: "0 0 4px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fdfdfd",
      }}
    >
      <AgGridReact
        rowData={gridItems}
        columnDefs={columnDefs}
        onCellFocused={onCellFocused}
        domLayout="autoHeight"
        suppressColumnVirtualisation
        suppressRowClickSelection
        suppressCellFocus
        suppressScrollOnNewData
      //headerHeight={50}
      //rowHeight={60}
      />
    </div>
  );
};

export default SingleGrid;